/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SkinConditionDetectRequestModel } from '../../models/skin-condition-detect-request-model';
import { SkinConditionDetectResponseModel } from '../../models/skin-condition-detect-response-model';

export interface ConsumerDetectSkinConditionPost$Params {
      body?: SkinConditionDetectRequestModel
}

export function consumerDetectSkinConditionPost(http: HttpClient, rootUrl: string, params?: ConsumerDetectSkinConditionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SkinConditionDetectResponseModel>> {
  const rb = new RequestBuilder(rootUrl, consumerDetectSkinConditionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SkinConditionDetectResponseModel>;
    })
  );
}

consumerDetectSkinConditionPost.PATH = '/Consumer/DetectSkinCondition';
